








import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-back',

})
export default class IBack extends Vue {

  @Prop({type: [String], default: '#FFFFFF'}) protected color!: string

}

